import { RouterModule, Routes } from '@angular/router';
import { ShoppingcartComponent } from './shoppingcart/shoppingcart.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: './shoppingcart/index#ShoppingCartModule' }
];



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts